import React from 'react';

export const CompanyTableHeader: React.FC = () => {
  return (
    <div 
      role="rowgroup"
      className="hidden md:grid md:grid-cols-12 gap-4 px-6 py-4 bg-[var(--bg-tertiary)] border-b border-[var(--border-color)] sticky top-0 z-10"
    >
      <div className="col-span-3 text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wide">
        Name
      </div>
      <div className="col-span-3 text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wide">
        Email
      </div>
      <div className="col-span-3 text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wide">
        Address
      </div>
      <div className="col-span-2 text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wide">
        Phone
      </div>
      <div className="col-span-1 text-sm font-semibold text-[var(--text-primary)] uppercase tracking-wide">
        Company
      </div>
    </div>
  );
};
